import { useState } from 'react'
import { resolveEnumOptionColor } from '~/common/styles/enum-colors'
import { EnumChip } from '~/components/shared/EnumChip'
import { EnumOptionMark } from '~/components/shared/EnumOptionMark'
import { SortableListItem } from '~/components/shared/SortableListItem'
import { EnumOptionEditPopover } from './EnumOptionEditPopover'
import { EnumOptionFormValue } from './types'

interface EnumOptionRowProps {
  option: EnumOptionFormValue
  otherLabels: string[]
  onChange: (option: EnumOptionFormValue) => void
  onDelete: () => void
  isMultiSelect: boolean
}

export const EnumOptionRow = ({
  option,
  otherLabels,
  onChange,
  onDelete,
  isMultiSelect,
}: EnumOptionRowProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const color = resolveEnumOptionColor(option.colorPreset, option.colorCustom)

  return (
    <SortableListItem id={option.rowId} onDelete={onDelete}>
      <EnumOptionEditPopover
        isMultiSelect={isMultiSelect}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onSave={onChange}
        option={option}
        otherLabels={otherLabels}
        triggerClassName="w-full justify-start p-0 text-start text-gray-10"
        triggerContent={
          // The row previews the option the way this column's cells will render it
          isMultiSelect ? (
            <EnumChip color={color} iconName={option.iconName} label={option.label} />
          ) : (
            <>
              <EnumOptionMark color={color} iconName={option.iconName} />
              <span className="truncate">{option.label}</span>
            </>
          )
        }
      />
    </SortableListItem>
  )
}
